import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import { useReturnExperience } from './returnExperience';
import type { ReturnExperienceData } from './returnExperience';

type ReturnExperienceContextProps = {
  returnExperienceData: ReturnExperienceData | null;
  showReturnExperience: boolean | undefined;
};

const ReturnExperienceContext = createContext<ReturnExperienceContextProps>({
  returnExperienceData: null,
  showReturnExperience: false,
});

interface ReturnExperienceContextProviderProps {
  showReturnExperience: boolean | undefined;
  children: ReactNode;
}

export const ReturnExperienceContextProvider = ({
  children,
  showReturnExperience,
}: ReturnExperienceContextProviderProps) => {
  const { returnExperienceData } = useReturnExperience();

  return (
    <ReturnExperienceContext.Provider value={{ returnExperienceData, showReturnExperience }}>
      {children}
    </ReturnExperienceContext.Provider>
  );
};

export const useReturnExperienceContext = () => useContext(ReturnExperienceContext);
